import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useAppContentHttp } from '@/core/api/app-contents'
import { AppContent, AppContentPayload } from '@/core/models/app-content'

export type AppContentCollection = {
    data: Array<AppContent>,
    meta?: MetaPayload,
    links?: any
}

const state: AppContentCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const appContentCollection: Module<AppContentCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: AppContentCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.map((item: AppContentPayload) => state.data.push(new AppContent(item)))
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useAppContentHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: AppContentCollection): AppContentCollection => {
            return state
        }
    }
}
